export class ApiException extends Error {

    constructor(url, status, message) {
        super(`${url} returned ${status} error with message ${message}`);
        this.url = url;
        this.status = status;
        this.message = message;
    }
}

export class RecordNotFound extends ApiException {
    constructor(url, status, message) {
        super(url, status, message);
    }
}

export class PermissionDenied extends ApiException {
    constructor(url, status, message) {
        super(url, status, message);
    }
}

export class ValidationError extends ApiException {
    constructor(url, status, message) {
        super(url, status, message);
    }
}

export class Notification extends Error {

    constructor(message, notification_type) {
        super(message);
        this.type = notification_type;
        this.message = message;
    }
}


export class SuccessNotification extends Notification {
    constructor(message) {
        super(message, 'success')
    }
}
export class DangerNotification extends Notification {
    constructor(message) {
        super(message, 'danger')
    }
}

export class ErrorNotification extends Notification {
    constructor(message) {
        super(message, 'error')
    }
}

export class UnauthenticatedException extends Error {

    constructor() {
        super(`No JWT token found`);
    }
}
